var _path, _path2, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 63,
    viewBox: "0 0 113 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3825 62.5708L32.9785 49.4844H18.0913L18.3825 62.5708Z",
    fill: "#98B9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0600586 25.7836C0.0600586 32.7386 2.48245 38.6749 7.32732 43.5928C12.1721 48.5107 18.0203 50.9696 24.872 50.9696H88.1197C94.9714 50.9696 100.82 48.5107 105.664 43.5928C110.509 38.6749 112.932 32.7385 112.932 25.7836C112.932 18.8287 110.509 12.8923 105.664 7.97446C100.82 3.05659 94.9714 0.597656 88.1197 0.597656L24.872 0.597664C18.0203 0.597664 12.1721 3.0566 7.32732 7.97446C2.48245 12.8923 0.0600586 18.8287 0.0600586 25.7836Z",
    fill: "#98B9F2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.37821,
    cy: 4.44421,
    rx: 4.37821,
    ry: 4.44421,
    transform: "matrix(-1 0 0 1 45.793 21.3301)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.37821,
    cy: 4.44421,
    rx: 4.37821,
    ry: 4.44421,
    transform: "matrix(-1 0 0 1 60.877 21.3301)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.37821,
    cy: 4.44421,
    rx: 4.37821,
    ry: 4.44421,
    transform: "matrix(-1 0 0 1 75.957 21.3301)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.f35b75326cc5b76e34609544542b6b8c.svg";
export { ForwardRef as ReactComponent };